import React, {useEffect, useRef, useState} from 'react';
import Email from '../../resources/icon/email.png';
import Department from '../../resources/icon/department.png';
import Syslog from '../../resources/icon/syslog.png';
import DbDump from '../../resources/icon/dbdump.png';
import ZipFile from '../../resources/icon/zipfile.png';
import {userLogout} from "../../api/auth/AuthService";
import {Link, useNavigate} from "react-router-dom";
import Notification from "./Notification";
import {isSystem} from "../commonmethod/CommonMethod";
import {getDownloadAdminFile} from "../../api/backup/BackupService";
import "./userMenu.css";

function UserIcon({src, alt}) {
    return <img src={src} alt={alt} className="userMenu-icon-img" />;
}

function UserSvgIcon({children}) {
    return (
        <span className="userMenu-icon-svg" aria-hidden>
            {children}
        </span>
    );
}

function UserMenuRow({icon, children, onClick, to}) {
    const className = "userMenu-row";

    if (to) {
        return (
            <Link to={to} className={className}>
                {icon}
                <span>{children}</span>
            </Link>
        );
    }

    if (onClick) {
        return (
            <button type="button" className={className} onClick={onClick}>
                {icon}
                <span>{children}</span>
            </button>
        );
    }

    return (
        <div className={`${className} is-static`}>
            {icon}
            <span>{children}</span>
        </div>
    );
}

function UserMenu({user}) {
    const IMG_BASE = import.meta.env.VITE_IMG_BASE;
    const [userOpen, setUserOpen] = useState(false);
    const userMenuRef = useRef(null);
    const navigate = useNavigate();

    async function logout() {
        try {
            await userLogout();
            window.location.replace("/");
        } catch {
            /* ignore */
        }
    }

    useEffect(() => {
        function handleClickOutside(event) {
            if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
                setUserOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const adminItems = isSystem(user) ? [
        {label: "로그", icon: <UserIcon src={Syslog} alt="" />, onClick: () => navigate('/logs')},
        {label: "파일백업", icon: <UserIcon src={ZipFile} alt="" />, onClick: () => getDownloadAdminFile("file")},
        {label: "DB백업", icon: <UserIcon src={DbDump} alt="" />, onClick: () => getDownloadAdminFile("db")},
    ] : [];

    return (
        <>
            <Notification />
            <div className="h-full user-info relative flex items-center" onClick={() => setUserOpen(!userOpen)}>
                {
                    user.portrait ? (
                        <img
                            alt=""
                            className="w-[30px] h-[30px] rounded-full object-cover"
                            src={`${IMG_BASE}${user.portrait}`}
                        />
                    ) : (
                        <div className="w-[30px] h-[30px] leading-[30px] rounded-full bg-blue-500 text-white font-bold text-[12px] text-center">
                            {user.name.substring(0, 1)}
                        </div>
                    )
                }
                <button type="button" className="mr-2 flex h-[24px] line-h-24">
                    <span className="inline-block mr-2" />
                    <span className="inline-block">{user.name} 님</span>
                </button>
                <button type="button" className="mr-4 mobile-none">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-3 h-3">
                        <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                    </svg>
                </button>
            </div>

            {userOpen && (
                <div ref={userMenuRef} className="userMenu-li">
                    <div className="userMenu-top">
                        <span className="userMenu-name">{user.name}</span>
                        <button type="button" className="userMenu-logout" onClick={logout}>
                            <UserSvgIcon>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                                </svg>
                            </UserSvgIcon>
                            로그아웃
                        </button>
                    </div>

                    <div className="userMenu-list">
                        <UserMenuRow icon={<UserIcon src={Email} alt="" />}>{user.email}</UserMenuRow>
                        <UserMenuRow icon={<UserIcon src={Department} alt="" />}>{user.department || "부서없음"}</UserMenuRow>

                        {adminItems.map((item) => (
                            <UserMenuRow key={item.label} icon={item.icon} onClick={item.onClick}>
                                {item.label}
                            </UserMenuRow>
                        ))}
                    </div>

                    <div className="userMenu-actions">
                        <UserMenuRow
                            to={`/settings/userAccount/list?selectedId=${user.id}`}
                            icon={(
                                <UserSvgIcon>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
                                    </svg>
                                </UserSvgIcon>
                            )}
                        >
                            개인설정
                        </UserMenuRow>

                        {user.auth.includes("ROLE_ADMIN") && (
                            <UserMenuRow
                                onClick={() => navigate('/adminmenu')}
                                icon={(
                                    <UserSvgIcon>
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M11.42 15.17 17.25 21A2.652 2.652 0 0 0 21 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 1 1-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 0 0 4.486-6.336l-3.276 3.277a3.004 3.004 0 0 1-2.25-2.25l3.276-3.276a4.5 4.5 0 0 0-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437 1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008Z" />
                                        </svg>
                                    </UserSvgIcon>
                                )}
                            >
                                관리자 설정
                            </UserMenuRow>
                        )}
                    </div>
                </div>
            )}
        </>
    );
}

export default UserMenu;
